import React, { Component } from "react";
import Select from "react-select";

/**
 * Componente Select especializado para operações assincronamente com proteção contra
 * memory leaks do padrão isMounted.
 * 
 * Uso: Use este componente quando usar a propriedade `asyncOptions` do React Select.
 * Ele previne automaticamente warnings de setState em componentes desmontados.
 * 
 * Problema resolvido: "Warning: setState(...): Can only update a mounted or mounting component"
 * Causa: Promises de requisições async resolvem após o componente desmontar
 * 
 * Exemplo:
 *   <SelectAsync
 *     asyncOptions={(input, callback) => service.search(input, callback)}
 *     cacheAsyncResults={false}
 *     value={selectedValue}
 *     onChange={handleChange}
 *   />
 */
class SelectAsync extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * Wrappeia asyncOptions para verificar se o componente ainda está montado
     * antes de invocar o callback. Isso previne memory leaks e warnings de setState.
     */
    wrapAsyncOptions = (asyncOptions) => {
        if (!asyncOptions) return undefined;

        return (input, callback) => {
            // Callback seguro que respeita o ciclo de vida do componente
            const safeCallback = (err, data) => {
                if (this._isMounted && typeof callback === "function") {
                    callback(err, data);
                }
            };

            // Executa asyncOptions original com callback protegido
            return asyncOptions(input, safeCallback);
        };
    };

    render() {
        const { asyncOptions, ...otherProps } = this.props;
        const wrappedAsyncOptions = this.wrapAsyncOptions(asyncOptions);

        return (
            <Select 
                {...otherProps}
                asyncOptions={wrappedAsyncOptions}
            />
        );
    }
}

export default SelectAsync;
